<template>
    <div class="dashboard-sharing-tokens--view">
        <div class="dashboard-sharing-tokens--view__header">
            <BaseMultiselect
                v-model="trackerFilter"
                :placeholder="$t('shared.assets')"
                :options="trackers"
                track-by="id"
                :custom-label="option => option.asset_details.name"
                block
                multiple
            />
            <div class="dashboard-sharing-tokens--view__add-button">
                <BaseButton size="medium" @click="handleAddTokenClick">
                    {{ $t('addToken') }}
                </BaseButton>
            </div>
        </div>

        <div class="dashboard-sharing-tokens--view__content">
            <SharingTokensTable
                :filter-tracker="trackerFilter"
                @clearFilter="trackerFilter = []"
            />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

import BaseButton from '../redesigned/BaseButton'
import BaseMultiselect from '../redesigned/BaseMultiselect'
import SharingTokensTable from '../SharingTokensTable'
import SharingTokenEditModal from '../redesigned/SharingTokenEditModal.vue'

export default {
    name: 'DashboardSharingTokensView',
    components: {
        BaseButton,
        BaseMultiselect,
        SharingTokensTable,
    },
    data() {
        return {
            trackerFilter: [],
        }
    },
    computed: {
        ...mapState('tracker', ['trackers']),
    },
    methods: {
        handleAddTokenClick() {
            this.$modal.show(
                SharingTokenEditModal,
                {
                    onSubmit: this.refreshList,
                },
                {
                    width: 400,
                    height: '75%',
                }
            )
        },
        refreshList() {
            const filter = [...this.trackerFilter]
            this.trackerFilter = []
            this.$nextTick(() => {
                this.trackerFilter = filter
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.dashboard-sharing-tokens--view {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;

    &__header {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        padding: 1.5rem 1rem 0.5rem 2rem;
        background-color: $color-gray-lighter-new;
        border-bottom: $style-border;

        & > * {
            margin-right: 1rem;
            margin-bottom: 1rem;
            max-width: 200px;
        }

        .base-multiselect {
            max-width: 240px;
        }
    }

    &__add-button {
        margin-left: auto;
        justify-content: center;
    }

    &__content {
        display: flex;
        overflow-y: auto;

        & > * {
            width: 100%;
            overflow-x: auto;
        }
    }

    @include respond-to('for-small-mobile-only') {
        &__filters {
            padding: 1rem 1rem 0;

            & > * {
                &:not(.base-button) {
                    margin-right: 0;
                    max-width: 100%;
                    width: 100%;
                }
            }
        }
    }
}
</style>

<i18n> 
{
    "en": {
        "addToken": "Create new token"
    },
    "de": {
        "addToken": "Neuen Token erstellen"
    },
    "fr": {
        "addToken": "Créer un nouveau token"
    },
    "it": {
        "addToken": "Creare un nuovo token"
    }
}
</i18n>
